import React from 'react';

const Menu = ({ 
  activeCategory, 
  setActiveCategory, 
  allProducts, 
  IS_UNDER_REVIEW,
  zoomedCard, 
  setZoomedCard, 
  setSelectedProduct 
}) => {
  const renderMenu = () => {
    const products = allProducts[activeCategory] || [];
    if (products.length === 0) return (
      <div className="empty-state">
        <h2>🚧 【{activeCategory}】领地暂无产品</h2>
      </div>
    );
    
    return (
      <div style={{ position: 'relative' }}>
        <div className="card-grid">
          {products.map((item) => (
            <div 
              key={item.id} 
              className={`poster-card ${zoomedCard === item.id ? 'is-zoomed' : ''}`}
              onClick={() => setZoomedCard(zoomedCard === item.id ? null : item.id)} 
            >
              <div className="image-box"></div>
              <div className="info-box">
                <div className="title-area">
                  <div className="en">{item.en}</div>
                  <div className="cn-price-row">
                    <span className="cn">{item.cn}</span>
                    {!IS_UNDER_REVIEW && <span className="price">¥{item.price}</span>}
                  </div>
                </div>
                <div className="divider"></div>
                <div className="desc">{item.desc}</div>
                <div className="ingredients">{item.ing}</div>
                {!IS_UNDER_REVIEW && (
                  <button 
                    className="add-btn" 
                    onClick={(e) => {
                      e.stopPropagation(); 
                      setSelectedProduct(item); 
                      setZoomedCard(null); 
                    }}
                  >
                    加入
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        {zoomedCard && (
          <div 
            style={{
              position: 'fixed',
              top: 0, left: 0, right: 0, bottom: 0,
              background: 'rgba(0,0,0,0.6)',
              zIndex: 999, 
              backdropFilter: 'blur(3px)'
            }} 
            onClick={() => setZoomedCard(null)} 
          />
        )}
      </div>
    );
  };

  return (
    /* 🛠️ 修改点 1: 为 layout 注入 flex 布局并锁定最小高度，确保它能吃掉剩余的所有屏幕空间 */
    <div className="layout" style={{ display: 'flex', minHeight: 'calc(100vh - 120px)', alignItems: 'stretch' }}>
      
      {/* 🛠️ 修改点 2: 显式声明 sidebar 的右边框，并利用 flex 自动拉伸特性让它“落地” */}
      <div className="sidebar" style={{ borderRight: '5px solid black', flexShrink: 0, height: 'auto' }}>
        {Object.keys(allProducts).map((cat) => (
          <button 
            key={cat} 
            className={`side-btn ${activeCategory === cat ? "active" : ""}`} 
            onClick={() => setActiveCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>
      
      {/* 🛠️ 修改点 3: 让商品区平分剩余宽度，并保持滚动独立性 */}
      <div className="order-area" style={{ flex: 1, paddingBottom: '80px', overflowY: 'auto' }}>
        {renderMenu()}
      </div>
    </div>
  );
};

export default Menu;